import { render, staticRenderFns } from "./TilesResultsBasic.vue?vue&type=template&id=327c870f&"
import script from "./TilesResultsBasic.vue?vue&type=script&lang=js&"
export * from "./TilesResultsBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports